module.exports = __webpack_public_path__ + "assets/img/user.32200969.svg";